import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import {
	Container,
	Top,
	LogoLink,
	SearchWrapper,
	UserSpace,
	UserButtonWrapper,
} from './headerTopStyles';
import {
	OverlayTrigger,
} from 'core/components/FullMobileOverlay';

// Import icons individually for better code splitting
import BurgerIcon from 'core/icons/BurgerIcon';
// Holiday logo change revert in 2023
// import Logo from 'core/icons/Logo';
import { default as Logo } from 'core/icons/Holiday2022Logo';
import SearchBar from 'core/components/SearchBar';
import ShopBag from 'core/components/ShopBag';
import MarketingCta from './MarketingCta';
import MenuCta from './MenuCta';
import userProps from './userProps';
import { LoginBubble } from 'core/components/Login';
import Trigger from 'core/components/Login/LoginBubble/Trigger';
import { isEmpty } from 'core/utils/objectUtils';
import { getColor } from 'core/utils';
import { ResponsiveCheck } from 'core/providers/Responsive';
// Loadables:
import UserIcon from 'core/icons/UserIcon';
const UserAccount = loadable(() => import('../UserAccount'), {
	fallback: <UserIcon stroke="currentColor" />
});

class HeaderTop extends Component {
	state = {
		clientSide: false
	}

	componentDidMount() {
		this.setState({ clientSide: true });
	}

	render() {
		const {
			user,
			burgerId,
			cartCount,
			toggleBottomEnabled,
			searchBar={},
		} = this.props;
		const { clientSide } = this.state;
		const noUser = isEmpty(user);
		return (
			<ResponsiveCheck>
				{({ isMobile }) => (
					<Container>
						<Top>
							{isMobile && (
								<OverlayTrigger triggerId={burgerId} largeTrigger={true}>
									<BurgerIcon fill={getColor("black")} />
								</OverlayTrigger>
							)}
							{/* data-name used for automation test_homepage */}
							<LogoLink data-name="header-logo-link" href="/" title="Cratejoy - Shop Subscription Boxes">
								<Logo />
							</LogoLink>
							<SearchWrapper>
								<SearchBar {...searchBar} />
							</SearchWrapper>
							<MarketingCta />
							<UserSpace>
								<MenuCta />
								<UserButtonWrapper id="marketplace-auth-button" clientSide={clientSide}>
									{!noUser
										? <UserAccount {...user} isMobile={isMobile} />
										: clientSide
											? <LoginBubble />
											: <Trigger as="a" href="/login" title="Sign in - Cratejoy" />
									}
								</UserButtonWrapper>
								<ShopBag cartCount={cartCount} toggleBottomEnabled={toggleBottomEnabled} />
							</UserSpace>
						</Top>
					</Container>
				)}
			</ResponsiveCheck>
		);
	}

	static propTypes = {
		user: userProps,
		burgerId: PropTypes.string,
		cartCount: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.string,
		]),
		toggleBottomEnabled: PropTypes.func,
		searchBar: PropTypes.object,
	}
}

export default HeaderTop;
